import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AUTH_DIALOG_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, AUTH_DIALOG_TRANSLATION_KEY, {
  AUTH_DIALOG_MOBILE_HEADER_TITLE: 'Únete hoy',
  AUTH_DIALOG_MOBILE_HEADER_SUBTITLE: 'Vive la mejor experiencia de aprendizaje creativa y digital.',
  AUTH_DIALOG_MOBILE_HEADER_TITLE_PROMO: '¡Estás a un paso de empezar!',
  AUTH_DIALOG_MOBILE_HEADER_SUBTITLE_PROMO: 'Regístrate y accede a los cursos gratuitos de Crehana',
  // Aside
  YOU_ARE_ABOUT_TO_START: 'Estás a un paso de empezar',
  GET: 'Obtén',
  FREE: ' gratis ',
  COURSES_AND_RESOURCES: 'acceso a cursos, Lives, recursos descargables y mucho más.',
  // Switcher
  REGISTER_TITLE: 'Únete hoy',
  REGISTER_SUBTITLE: 'Sé parte de la nueva generación de profesionales digitales.',
  LOGIN_TITLE: 'Bienvenido de Vuelta',
  LOGIN_MODAL_SUBTITLE: 'Inicia sesión para seguir aprendiendo',
  LOGIN_REGISTER_CONTINUE: 'o continúa con',
  LOGIN_REGISTER_CONTINUE_2: 'O crea una cuenta con',
  REGISTER: 'Regístrate',
  LOGIN_NOT_MEMBER: '¿Aún no eres miembro?',
  REGISTER_NOT_MEMBER: '¿Tienes una cuenta?',
  LOGIN_REGISTER: 'Regístrate',
  REGISTER_LOGIN: 'Inicia Sesión',
  // SignIn
  AUTH_VALIDATION_USER_LENGTH: 'El campo usuario debe tener entre 6 y 75 caracteres',
  AUTH_VALIDATION_PASSWORD_LENGTH: 'Tu contraseña debe de tener entre 6 y 20 caracteres',
  LOGIN_EMAIL: 'Usuario o Correo electrónico',
  AUTH_VALIDATION_REQUIRED: 'Campo requerido',
  LOGIN_PASSWORD: 'Contraseña',
  LOGIN_FORGET_PASSWORD: '¿Olvidaste tu contraseña?',
  LOGIN_MAIN_BUTTON: 'Inicia Sesión',
  // SignUp
  REGISTER_EMAIL: 'Correo electrónico',
  AUTH_VALIDATION_EMAIL_IN_USE: 'El email ingresado ya se encuentra en uso',
  AUTH_VALIDATION_VALID_EMAIL: 'Ingresa una dirección de correo válida',
  AUTH_VALIDATION_LEGALS_REQUIRED: 'Debes aceptar los Términos, Condiciones y Políticas para continuar.',
  REGISTER_FIRST_NAME: 'Nombre',
  REGISTER_LASTNAME: 'Apellido',
  // Affiliate aside
  AFFILIATE_REGISTER_TITLE_PART_A: 'Registrate y Gana\n',
  AFFILIATE_REGISTER_TITLE_PART_B: 'hasta el 20% del monto de la compra.',
  AFFILIATE_LOGIN_TITLE: 'Únete hoy',
  AFFILIATE_LOGIN_SUBTITLE: 'Sé parte de la nueva generación de profesionales digitales.'
});